import axios from "axios";

export default axios.create({
  //baseURL: "http://localhost:7269/api",
  baseURL: "https://adventuriesapi20230325184941.azurewebsites.net/api",
  headers: {
    "Content-type": "application/json"
  }
});